import { LayoutWithTeamExistanceChecker } from "../layout";
import { MemberCard } from "../team-members/team-member-card";
import { useTeam } from "../team-members/team-member-context";
import { Round, usePairMatrix } from "../pair-matrix/pair-matrix-context";

function Square(props: any) {
  if (props.blocked) {
    return (
      <div className="bg-black min-w-40">
        {props.children}
      </div>
    );
  }

  if (props.pairing) {
    return (
      <div className="bg-red-100 min-w-40">
        {props.children}
      </div>
    );
  }

  return (
    <div className="bg-gray-100 min-w-40">
      {props.children}
    </div>
  );
}

export function PairMatrix() {
  const { teamMembers } = useTeam();
  const { round, removePair, computePair, startRound, isCurrentPairing, currentPairs, matrix } = usePairMatrix();

  return (
    <LayoutWithTeamExistanceChecker>
      <div className="flex">
        <h2 className="pt-5 pb-5 text-5xl">Round {round.length || 1}</h2>
        <button onClick={() => startRound()} className="pt-5 pl-5">Start a new round</button>
      </div>

      {currentPairs.map((pair: any, index: number) => {
        return (
          <p key={`${pair[0].id}-${pair[1].id}-${index}`}>
            {pair[0].name} + {pair[1].name} - <button onClick={() => removePair(index)}>remove</button>
          </p>
        );
      })}

      {teamMembers.length > 0 && <div>
        <div className="flex">
          <Square blocked />

          {teamMembers.map(m => <Square key={m.id}>
            <MemberCard member={m} />
          </Square>)}
        </div>

        {matrix.map((row:any, i: number) => (
          <div key={i} className="flex">
            <Square key={i}>
              <MemberCard member={teamMembers[i]} />
            </Square>
            {row.map((col: any, j: number) => (
              <Square key={j} blocked={i === j} pairing={isCurrentPairing(matrix[i][j])}>
                {!isCurrentPairing(matrix[i][j]) && <button onClick={() => computePair(i, j)}>pair up!</button>}
              </Square>
            ))}
          </div>
        ))}

        <h2 className="pt-5 pb-5">Closed rounds</h2>
        {round.map((round: Round, index: number) => {
          return <div key={`${round.turn}-${index}`}>
            <p className="text-lg">Round {index + 1}</p>
            {round.pairs.map((pair, indexPair: number) => {
              return (
                <div key={`${pair[0].id}-${pair[1].id}-${indexPair}`}>
                  {pair[0].name} + {pair[1].name}
                </div>
              )
            })}
          </div>
        })}
      </div>}
    </LayoutWithTeamExistanceChecker>
  );
}